(function () {
  function init(section) {
    if (section.__hoadFcReady) return;
    section.__hoadFcReady = true;
    var grid = section.querySelector('[data-hoad-fc-grid]');
    var dots = section.querySelectorAll('.hoad-fc__dot');
    if (!grid || !dots.length) return;
    grid.addEventListener(
      'scroll',
      function () {
        var cards = grid.querySelectorAll('.hoad-fc__card');
        var cardWidth = cards[0] ? cards[0].offsetWidth + 16 : 1;
        var index = Math.round(grid.scrollLeft / cardWidth);
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === index);
        });
      },
      { passive: true }
    );
  }

  function boot() {
    document.querySelectorAll('[data-hoad-fc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-hoad-fc]');
    if (s) init(s);
  });
})();
